import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/TransformerRectifiersCoalPowerHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-37.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .trcp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .trcp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .trcp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .trcp-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .trcp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .trcp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .trcp-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .trcp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .trcp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .trcp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .trcp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .trcp-bc-item:hover { color: #EB2019; }
  .trcp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .trcp-bc-sep img { width: 24px; height: 24px; display: block; }
  .trcp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .trcp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .trcp-main-section { padding: 80px 0 120px 0; }
  .trcp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .trcp-article { flex: 1; min-width: 0; }

  .trcp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .trcp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .trcp-meta-item:last-child { border-right: none; padding-right: 0; }
  .trcp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .trcp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .trcp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .trcp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .trcp-article-body p { margin-bottom: 20px; }
  .trcp-article-body p:last-child { margin-bottom: 0; }

  .trcp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .trcp-article-body strong { font-weight: 600; color: #202020; }

  .trcp-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; display: block; margin-bottom: 20px; }
  .trcp-red-link:hover { opacity: 0.8; }

  .trcp-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .trcp-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .trcp-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .trcp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .trcp-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .trcp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .trcp-nav-btn:hover { color: #EB2019; }
  .trcp-nav-btn img { width: 40px; height: 40px; display: block; }

  .trcp-share-icons { display: flex; align-items: center; gap: 20px; }
  .trcp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .trcp-share-icon:hover { opacity: 0.85; }
  .trcp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .trcp-sidebar { flex: 0 0 475px; }
  .trcp-sidebar-block { margin-bottom: 60px; }
  .trcp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .trcp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .trcp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .trcp-recent-item:hover .trcp-recent-title { color: #EB2019; }
  .trcp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .trcp-recent-body { flex: 1; min-width: 0; }
  .trcp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .trcp-social-icons { display: flex; align-items: center; gap: 30px; }
  .trcp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .trcp-social-icon:hover { opacity: 0.8; }
  .trcp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .trcp-hero             { height: 350px; }
    .trcp-hero-content     { padding: 0 32px; }
    .trcp-hero-title       { font-size: 30px; }
    .trcp-hero-divider     { width: 100%; max-width: 479px; }
    .trcp-breadcrumb       { padding: 24px 0 0 0; }
    .trcp-breadcrumb-inner { padding: 0 32px; }
    .trcp-inner            { padding: 0 32px; }
    .trcp-main-section     { padding: 48px 0 60px 0; }
    .trcp-main-row         { flex-direction: column; gap: 48px; }
    .trcp-sidebar          { flex: none; width: 100%; }
    .trcp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .trcp-hero             { height: 360px; }
    .trcp-hero-content     { padding: 0 16px; }
    .trcp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .trcp-hero-divider     { width: 100%; }
    .trcp-hero-subtitle    { font-size: 14px; }
    .trcp-breadcrumb       { padding: 30px 0 0 0; }
    .trcp-breadcrumb-inner { padding: 0 16px; }
    .trcp-bc-item          { font-size: 14px; gap: 14px; }
    .trcp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .trcp-bc-sep img       { width: 22px; height: 22px; }
    .trcp-inner            { padding: 0 16px; }
    .trcp-main-section     { padding: 30px 0 60px 0; }
    .trcp-main-row         { flex-direction: column; gap: 60px; }
    .trcp-sidebar          { flex: none; width: 100%; }
    .trcp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .trcp-article-body     { font-size: 14px; }
    .trcp-article-body p   { margin-bottom: 15px; }
    .trcp-article-body strong { font-size: 16px; }
    .trcp-meta-item        { font-size: 14px; }
    .trcp-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .trcp-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .trcp-hashtags         { margin-top: 30px; font-size: 14px; }
    .trcp-nav-btn img      { width: 24px; height: 24px; }
    .trcp-nav-btn          { font-size: 14px; }
    .trcp-share-icon img   { width: 34px; height: 34px; }
    .trcp-sidebar-title    { font-size: 20px; }
    .trcp-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },

];

export default function TransformerRectifiersCoalPower() {
  return (
    <div className="trcp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="trcp-hero">
        <img className="trcp-hero-bg" src={HeroBgImg} alt="The Role of Transformer Rectifiers in Coal-Fired Power Plants Hero" />
        <div className="trcp-hero-overlay" />
        <div className="trcp-hero-content">
          <h1 className="trcp-hero-title">
            The Role of Transformer Rectifiers in Enhancing Efficiency and Reducing Emissions in Coal-Fired Power Plants
          </h1>
          <hr className="trcp-hero-divider" />
          <p className="trcp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="trcp-breadcrumb" aria-label="Breadcrumb">
        <div className="trcp-breadcrumb-inner">
          <a href="/" className="trcp-bc-item">Home</a>
          <span className="trcp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="trcp-bc-item">News &amp; Updates</a>
          <span className="trcp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="trcp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="trcp-main-section">
        <div className="trcp-inner">
          <div className="trcp-main-row">

            {/* ── ARTICLE ── */}
            <article className="trcp-article">

              {/* Meta bar */}
              <div className="trcp-meta-bar">
                <span className="trcp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="trcp-meta-item"><img src={CalendarIcon} alt="date" /> October 4, 2024</span>
                <span className="trcp-meta-item"><img src={ClockIconImg} alt="time" /> 5:43 am</span>
                <span className="trcp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="trcp-article-title">
                The Role of Transformer Rectifiers in Enhancing Efficiency and Reducing Emissions in Coal-Fired Power Plants
              </h1>

              {/* Body */}
              <div className="trcp-article-body">

                <p>Given the recent environmental attention, coal-fired power plants are being used to improve efficiency and decrease ecological emissions. One pivotal technology is the transformer rectifier, a critical tool for Electrostatic Precipitators. The latter reduces particulate emissions in different industries, such as power, steel, and cement.</p>

                {/* Article image */}
                <img className="trcp-article-img" src={ArticleImg} alt="Transformer Rectifiers in Coal-Fired Power Plants" />

                <a href="/" className="trcp-red-link">ADOR Powertron: Leading the Way in Pollution Control</a>

                <p>At the fore of this technology is <strong>ADOR POWERTRON Ltd.</strong>, an ISO 9001-certified organization and one of the world's most prominent manufacturers and suppliers of <strong>Transformer Rectifier (T/R) sets</strong>. In the last 35 years, ADOR has supplied over 20,000+ high-voltage <a href="/products/esp-power-supplies/3-phase-solutions" className="trcp-red-link-plain">transformer rectifier</a> units to more than 200 satisfied clients across 82 countries, significantly influencing pollution control in enterprises, including coal-fired power plants.</p>

                <span className="trcp-h2">What is a Transformer Rectifier?</span>

                <p>A transformer rectifier is an important device in Electrostatic Precipitators (ESPs). It converts high-voltage AC (alternating current) to high-voltage DC (direct current), which is essential for the ESP to function effectively. ESPs help capture and remove particulate matter from the flue gases emitted by coal-fired power plants, capturing up to 99% of the ash and soot and significantly reducing air pollution.</p>

                <span className="trcp-h2">The Environmental Impact of Coal-Fired Power Plants</span>

                <p>Coal-fired power plants have affected air quality by emitting high levels of particulate matter, such as ash, dust, and other substances. ESPs and the transformer rectifier can guarantee a steady and high-voltage DC supply and significantly decrease the percentage of particulates exiting the atmosphere.</p>

                <span className="trcp-h2">Challenges in Achieving High Efficiency and Low Emissions</span>

                <p>The most significant challenge for coal-fired power plants is providing an equally high efficiency level and the lowest environmental influence. For this reason, the efficiency of the electrostatic precipitators or ESPs fitted to eradicate fine particulates from the flue gas is critical. On-site adaptively designed impedance matching transformers are crucial in using the maximum power of the ESP. Therefore, some minimal flue gases are released into the atmosphere, which can maintain the environment's standards. Thus, energy consumption and dust collection efficiency during ESP operations remain among the most significant challenges for coal-fired power plants.</p>

                <span className="trcp-h2">Approach for Further Efficiency Improvements</span>

                <p>At the same time, further improvements in this field require a sophisticated approach to ESPs and the elements that ensure their functioning, including power supplies and control mechanisms.</p>

                <span className="trcp-h2">Key Objectives of Optimizing ESP Performance</span>

                <p>It has become evident that using the approach mentioned above can help attain several critical objectives, such as:</p>

                <p>Adjust the voltage supplied to the ESP to maximize the dust collection process's efficiency and minimize energy consumption.</p>

                <p>Use on-site-developed software and control systems to control the power supply's performance and ensure the ESP's maximum performance throughout its lifespan.</p>

                <span className="trcp-h2">What is so unique about Ador transformer rectifiers?</span>

                <p>ADOR's transformer rectifiers enhance operational efficiency and emission control, contributing to the long-term sustainability of coal-fired power plants. By optimizing ESP performance, these devices enable power plants to meet strict environmental laws while maintaining high efficiency. As global industries focus on reducing their environmental impact, solutions like ADOR's technology are critical for achieving cleaner energy production.</p>

                <span className="trcp-h2">In a Nutshell</span>

                <p>Transformer rectifiers are very important in coal-fired power plants. These devices increase the efficiency of electrostatic precipitators and help reduce particulates efficiently, contributing to the sustainable development of power plants. With over 35 years of growth in partnership with Redkoh technology, Ador Powertron Ltd. is the leader in <a href="/products/esp-power-supplies/3-phase-solutions" className="trcp-red-link-plain">transformer rectifiers</a> and providing solutions for pollution control in industries worldwide.</p>

                <p><a href="/contact-us" className="trcp-red-link-plain">Contact us</a> today and make a significant step towards a better future.</p>

                <p>With over 20,000+ High-Voltage Transformer-Rectifier units supplied and 200+ satisfied customers over the past 35 years, ADOR has established a strong footprint within the Power, Cement, Steel, Pulp, and Paper industries across 82 countries spanning six continents.</p>

                <p>ADOR T/Rs handle both single-phase and multi-phase systems, ensuring stable and efficient power generation. They use software developed in-house and can also incorporate OEM software for managing and controlling the ESP.</p>

                <p>ADOR has committed to investing in these areas and will research innovative solutions to fight pollution and sustainable energy. To achieve this goal, Ador has a strategic technology-sharing partnership with Redkoh, the world's foremost precipitator controls company.</p>

                <p className="trcp-hashtags"><strong>#TransformerRectifier #PollutionControl #CoalFiredPowerPlants #EmissionReduction #CleanEnergySolutions #SustainableEnergy #EnvironmentalProtection #EnergyEfficiency</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="trcp-bottom-row">
                <div className="trcp-bottom-nav">
                  <a href="/news/switch-mode-power-supply-esp" className="trcp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/igbt-technology-esp" className="trcp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="trcp-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/role-of-transformer-rectifiers-in-enhancing-efficiency/" className="trcp-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Frole-of-transformer-rectifiers-in-enhancing-efficiency%2F&mode=login" className="trcp-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Frole-of-transformer-rectifiers-in-enhancing-efficiency%2F%26title%3DTransformer%2520Rectifiers%2520Boost%2520Coal%2520Plant%2520Efficiency%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Frole-of-transformer-rectifiers-in-enhancing-efficiency%2F" className="trcp-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="trcp-sidebar">

              {/* Recent Posts */}
              <div className="trcp-sidebar-block">
                <p className="trcp-sidebar-title">Recent Posts</p>
                <div className="trcp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="trcp-recent-item">
                      <img src={post.img} alt={post.title} className="trcp-recent-img" />
                      <div className="trcp-recent-body">
                        <span className="trcp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="trcp-sidebar-block">
                <p className="trcp-sidebar-title">Social Media</p>
                <div className="trcp-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="trcp-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="trcp-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}